import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addPayment } from '../redux/slices/paymentSlice';
import { fetchDoctors } from '../redux/slices/doctorSlice';
import { fetchSubscriptionPlans } from '../redux/slices/subscriptionPlanSlice';
import '../styles/FormStyles.css';

const PaymentForm = () => {
  const dispatch = useDispatch();
  const { loading: paymentLoading, error } = useSelector((state) => state.payments);
  const { doctors } = useSelector((state) => state.doctors);
  const { plans } = useSelector((state) => state.subscriptionPlans);

  const [formData, setFormData] = useState({
    doctorId: '',
    planId: '',
    amount: '',
  });

  useEffect(() => {
    dispatch(fetchDoctors());
    dispatch(fetchSubscriptionPlans());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Auto-fill amount when plan is selected
    if (name === 'planId' && value) {
      const selectedPlan = plans.find((p) => p.plan_id === parseInt(value));
      if (selectedPlan) {
        setFormData((prev) => ({
          ...prev,
          amount: selectedPlan.price,
        }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.doctorId || !formData.planId || !formData.amount) {
      alert('Please fill in all fields');
      return;
    }
    dispatch(addPayment({
      doctorId: parseInt(formData.doctorId),
      planId: parseInt(formData.planId),
      amount: parseFloat(formData.amount),
    }));
    setFormData({
      doctorId: '',
      planId: '',
      amount: '',
    });
  };

  return (
    <div className="form-container">
      <h3>Process Subscription Payment</h3>
      <form onSubmit={handleSubmit} className="modern-form">
        <div className="form-group">
          <label htmlFor="doctorId">Doctor</label>
          <select
            id="doctorId"
            name="doctorId"
            value={formData.doctorId}
            onChange={handleChange}
            disabled={paymentLoading}
          >
            <option value="">Select a doctor</option>
            {doctors.map((doctor) => (
              <option key={doctor.doctor_id} value={doctor.doctor_id}>
                {doctor.first_name} {doctor.last_name} ({doctor.email})
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="planId">Subscription Plan</label>
          <select
            id="planId"
            name="planId"
            value={formData.planId}
            onChange={handleChange}
            disabled={paymentLoading}
          >
            <option value="">Select a plan</option>
            {plans.map((plan) => (
              <option key={plan.plan_id} value={plan.plan_id}>
                {plan.name} - ₹{parseFloat(plan.price).toFixed(2)} ({plan.duration_months} months)
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="amount">Amount (₹)</label>
          <input
            type="number"
            id="amount"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            placeholder="Amount will auto-fill"
            step="0.01"
            disabled={paymentLoading}
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <button type="submit" className="submit-btn" disabled={paymentLoading}>
          {paymentLoading ? 'Processing...' : 'Process Payment'}
        </button>
      </form>
    </div>
  );
};

export default PaymentForm;
